// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/HUD/no_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview {
  position: fixed;
  top: 10px;
  pointer-events: auto;
  margin: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
  transition: all .2s;
}

/* Position the left overview */
.overview:not(.overview_right) {
  left: 10px;
}

/* Position the right overview */
.overview.overview_right {
  right: 10px;
  align-items: flex-end;
}

.overview_playerteam {
  cursor: var(--game-pointer);
  transition: all .2s;
}

/* Update the media queries for scaling */
@media screen and (max-width: 1500px) and (orientation: landscape) {
  .overview:not(.overview_right) {
    transform: scale(0.9);
    transform-origin: top left;
  }
  
  .overview.overview_right {
    transform: scale(0.9);
    transform-origin: top right;
  }
  
  .overview_playerteam {
    transform: scale(0.9);
    transform-origin: top right;
  }
}

@media screen and (max-width: 1400px) and (orientation: landscape) {
  .overview:not(.overview_right) {
    transform: scale(0.75);
  }
  
  .overview.overview_right {
    transform: scale(0.75);
  }
  
  .overview_playerteam {
    transform: scale(0.75);
  }
}

@media screen and (max-width: 1100px) and (orientation: landscape) {
  .overview:not(.overview_right) {
    transform: scale(0.65);
  }
  
  .overview.overview_right {
    transform: scale(0.65);
  }
  
  .overview_playerteam {
    transform: scale(0.65);
  }
}

@media screen and (max-width: 980px) and (orientation: landscape) {
  .overview:not(.overview_right) {
    transform: scale(0.55);
  }
  
  .overview.overview_right {
    transform: scale(0.55);
  }
  
  .overview_playerteam {
    transform: scale(0.55);
  }
}

.member {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Kim', sans-serif;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  color: white;
}

.member_container {
  position: absolute;
  top: 128px;
}

.char_stats_container {
  display: flex;
  flex-direction: row;
}

.char_profile {
  background-size: 100% 100%;
}

.char_profile_container {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  padding-bottom: 6px;
  background-size: 100% 100%;
  z-index: 20;
}

.char_portrait {
  width: 100%;
  height: 100%;
  background-position: -40px -40px;
  background-repeat: no-repeat;
  transform: scale(0.7);
}

.char_portrait_right {
  margin-left: 6px;
}

.char_alive_animation {
  animation: animate-sprite 0.7s steps(1) infinite;
}

.char_stats {
  background-size: 100% 100%;
  height: 55px;
  width: 130px;
  margin-left: -16px;
  margin-bottom: 4px;
  padding: 8px;
  padding-left: 22px;
  padding-right: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.char_stats_right {
  margin-left: 0;
  margin-right: -16px;
  padding-left: 12px;
  padding-right: 20px;
}

.char_stats_right .char_stats_player_name {
  flex-direction: row-reverse;
}

.char_stats_player_name {
  display: flex;
  gap: 6px;
  align-items: center;
}

.char_stats_player_index {
  min-width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.char_stats_player_name p {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.char_stats_bar {
  background-color: #0e0e0e;
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
  height: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.char_stats_hp {
  background-color: #ca304d;
  border-radius: 3px;
  height: 100%;
  transition: width 0.3s ease-out;
}

.char_stats_mp {
  background-color: #4583d0;
  border-radius: 3px;
  height: 100%;
  transition: width 0.3s ease-out;
}

.char_statuses {
  display: flex;
  gap: 4px;
  align-items: center;
  position: absolute;
  left: 80px;
  top: 60px;
}

.char_statuses_right {
  left: auto;
  top: 60px;
  right: 78px;
}

.char_statuses img {
  width: 18px;
  height: 20px;
  background-color: #1c1f25;
  padding: 2px;
  border-radius: 2px;
}

/* Add new team label styles */
.team_label {
  font-family: 'Kim', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  padding: 2px 12px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(113, 222, 255, 0.1) 20%,
    rgba(113, 222, 255, 0.15) 50%,
    rgba(113, 222, 255, 0.1) 80%,
    transparent
  );
  border-radius: 2px;
  text-shadow: 0 0 10px rgba(113, 222, 255, 0.3);
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.team_label::before,
.team_label::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 15px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(113, 222, 255, 0.4),
    transparent
  );
}

.team_label::before {
  left: -20px;
}

.team_label::after {
  right: -20px;
}

@media screen and (max-width: 1500px) and (orientation: landscape) {
  .team_label {
    font-size: 11px;
  }
}

@media screen and (max-width: 1400px) and (orientation: landscape) {
  .team_label {
    font-size: 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/HUD/Overview.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,iEAAiE;EACjE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yDAA8C;EAC9C,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB;;;;;;;GAOC;EACD,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".overview {\n  position: fixed;\n  top: 10px;\n  pointer-events: auto;\n  margin: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 6px;\n  transition: all .2s;\n}\n\n/* Position the left overview */\n.overview:not(.overview_right) {\n  left: 10px;\n}\n\n/* Position the right overview */\n.overview.overview_right {\n  right: 10px;\n  align-items: flex-end;\n}\n\n.overview_playerteam {\n  cursor: var(--game-pointer);\n  transition: all .2s;\n}\n\n/* Update the media queries for scaling */\n@media screen and (max-width: 1500px) and (orientation: landscape) {\n  .overview:not(.overview_right) {\n    transform: scale(0.9);\n    transform-origin: top left;\n  }\n  \n  .overview.overview_right {\n    transform: scale(0.9);\n    transform-origin: top right;\n  }\n  \n  .overview_playerteam {\n    transform: scale(0.9);\n    transform-origin: top right;\n  }\n}\n\n@media screen and (max-width: 1400px) and (orientation: landscape) {\n  .overview:not(.overview_right) {\n    transform: scale(0.75);\n  }\n  \n  .overview.overview_right {\n    transform: scale(0.75);\n  }\n  \n  .overview_playerteam {\n    transform: scale(0.75);\n  }\n}\n\n@media screen and (max-width: 1100px) and (orientation: landscape) {\n  .overview:not(.overview_right) {\n    transform: scale(0.65);\n  }\n  \n  .overview.overview_right {\n    transform: scale(0.65);\n  }\n  \n  .overview_playerteam {\n    transform: scale(0.65);\n  }\n}\n\n@media screen and (max-width: 980px) and (orientation: landscape) {\n  .overview:not(.overview_right) {\n    transform: scale(0.55);\n  }\n  \n  .overview.overview_right {\n    transform: scale(0.55);\n  }\n  \n  .overview_playerteam {\n    transform: scale(0.55);\n  }\n}\n\n.member {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: 'Kim', sans-serif;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  color: white;\n}\n\n.member_container {\n  position: absolute;\n  top: 128px;\n}\n\n.char_stats_container {\n  display: flex;\n  flex-direction: row;\n}\n\n.char_profile {\n  background-size: 100% 100%;\n}\n\n.char_profile_container {\n  width: 70px;\n  height: 70px;\n  border-radius: 8px;\n  padding-bottom: 6px;\n  background-size: 100% 100%;\n  z-index: 20;\n}\n\n.char_portrait {\n  width: 100%;\n  height: 100%;\n  background-position: -40px -40px;\n  background-repeat: no-repeat;\n  transform: scale(0.7);\n}\n\n.char_portrait_right {\n  margin-left: 6px;\n}\n\n.char_alive_animation {\n  animation: animate-sprite 0.7s steps(1) infinite;\n}\n\n.char_stats {\n  background-size: 100% 100%;\n  height: 55px;\n  width: 130px;\n  margin-left: -16px;\n  margin-bottom: 4px;\n  padding: 8px;\n  padding-left: 22px;\n  padding-right: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.char_stats_right {\n  margin-left: 0;\n  margin-right: -16px;\n  padding-left: 12px;\n  padding-right: 20px;\n}\n\n.char_stats_right .char_stats_player_name {\n  flex-direction: row-reverse;\n}\n\n.char_stats_player_name {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.char_stats_player_index {\n  min-width: 24px;\n  height: 24px;\n  background-image: url(\"@assets/HUD/no_bg.png\");\n  background-size: 100% 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n}\n\n.char_stats_player_name p {\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.char_stats_bar {\n  background-color: #0e0e0e;\n  border-radius: 2px;\n  overflow: hidden;\n  width: 100%;\n  height: 4px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.char_stats_hp {\n  background-color: #ca304d;\n  border-radius: 3px;\n  height: 100%;\n  transition: width 0.3s ease-out;\n}\n\n.char_stats_mp {\n  background-color: #4583d0;\n  border-radius: 3px;\n  height: 100%;\n  transition: width 0.3s ease-out;\n}\n\n.char_statuses {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  position: absolute;\n  left: 80px;\n  top: 60px;\n}\n\n.char_statuses_right {\n  left: auto;\n  top: 60px;\n  right: 78px;\n}\n\n.char_statuses img {\n  width: 18px;\n  height: 20px;\n  background-color: #1c1f25;\n  padding: 2px;\n  border-radius: 2px;\n}\n\n/* Add new team label styles */\n.team_label {\n  font-family: 'Kim', sans-serif;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-align: center;\n  padding: 2px 12px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(113, 222, 255, 0.1) 20%,\n    rgba(113, 222, 255, 0.15) 50%,\n    rgba(113, 222, 255, 0.1) 80%,\n    transparent\n  );\n  border-radius: 2px;\n  text-shadow: 0 0 10px rgba(113, 222, 255, 0.3);\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n\n.team_label::before,\n.team_label::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 15px;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(113, 222, 255, 0.4),\n    transparent\n  );\n}\n\n.team_label::before {\n  left: -20px;\n}\n\n.team_label::after {\n  right: -20px;\n}\n\n@media screen and (max-width: 1500px) and (orientation: landscape) {\n  .team_label {\n    font-size: 11px;\n  }\n}\n\n@media screen and (max-width: 1400px) and (orientation: landscape) {\n  .team_label {\n    font-size: 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
